import { Link, usePage } from '@inertiajs/react'
import Logo from './Logo'

export default function AuthenticatedLayout({ children }) {
  const { auth } = usePage().props
  const { user } = auth

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center gap-6">
              <Link href="/dashboard" className="flex items-center">
                <Logo />
              </Link>
              <Link href="/my_stores" className="text-sm text-indigo-600 hover:underline">
                Mina försäljningar
              </Link>
              {(user?.org_admin || user?.team_admin) && (
                <>
                  <div className="w-px h-5 bg-gray-200" />
                  <span className="text-xs font-medium text-gray-400 uppercase tracking-wide">Admin</span>
                  {user?.org_admin ? (
                    <>
                      <Link href="/activities" className="text-sm text-indigo-600 hover:underline">
                        Aktiviteter
                      </Link>
                      <Link href="/teams" className="text-sm text-indigo-600 hover:underline">
                        Lag
                      </Link>
                      <Link href="/users" className="text-sm text-indigo-600 hover:underline">
                        Användare
                      </Link>
                    </>
                  ) : (
                    <Link href="/teams" className="text-sm text-indigo-600 hover:underline">
                      Lag
                    </Link>
                  )}
                </>
              )}
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm text-gray-600">{user?.name}</span>
              <Link
                href="/sign_out"
                method="delete"
                as="button"
                className="text-sm text-indigo-600 hover:underline"
              >
                Logga ut
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {auth.flash?.notice && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
          <div className="bg-green-50 border border-green-200 text-green-800 rounded-md px-4 py-3 text-sm">
            {auth.flash.notice}
          </div>
        </div>
      )}
      {auth.flash?.alert && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4">
          <div className="bg-red-50 border border-red-200 text-red-800 rounded-md px-4 py-3 text-sm">
            {auth.flash.alert}
          </div>
        </div>
      )}

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  )
}
